export const monitorsQueryKeys = {
  datadog: ({
    integrationName,
    monitorId,
    teamId
  }: {
    integrationName: string
    monitorId: string
    teamId: string
  }) =>
    [
      `/datadog/monitors/${monitorId}`,
      { datadogIntegrationName: integrationName, teamId }
    ] as const
}
